import React, { Fragment } from 'react';
import styled from "styled-components";

const Wrapper = styled.div`
    text-align: left;
    display: inline-block;
    width: 100%;
    margin-bottom: 36px;

    ${props => props.theme.mediaQueries.medium}{
        //max-width: 250px;
    };
`;

const Icon = styled.svg`
    float: left;
    width: ${props => props.widthIcon || '30px'};
    height: ${props => props.heightIcon || '30px'};
    display: inline-block;
    background-image: url(${props => props.backgroundImg});
    background-repeat: no-repeat;
    
    ${props => props.theme.mediaQueries.medium}{
        //margin-top: 50px;
    };
`;

const Header = styled.p`
    font-size: ${props => props.fontSizeHeader || '1.33rem'};
    line-height: ${props => props.lineHeightHeader || '24px'};
    margin-top:  ${props => props.marginTopHeader || '16px'};
    margin-left: ${props => props.marginLeftHeader || '54px'};

    ${props => props.theme.mediaQueries.medium}{
        font-size: ${props => props.fontSizeHeaderMediaQueriesMedium || '0.9rem'};
        margin-top: ${props => props.marginTopHeaderMediaQueriesMedium}
    };
`

const P = styled.p`
    margin-left: ${props => props.marginLeftP || '54px'};

    ${props => props.theme.mediaQueries.medium}{
        font-size: 0.8rem;
        line-height: 24px;
        padding-top: 2px;
        margin-left: ${props => props.marginLeftPMediaQueriesMedium || '62px'};
    };
`      

const IconTextLeftToRight = ({ 
    backgroundImg,
    headerText,
    paragraphText,
    content,
    ...props
}) => {
    const renderIconTextLeftToRight = (content) => {
        return content.map((item, index) => {
            return (
                <Wrapper key={index}>
                    <Icon
                        {...props}
                        backgroundImg={item.backgroundImg}
                    />

                    {item.headerText &&
                        <Header
                            {...item.props}
                        >
                            {item.headerText}
                        </Header>}

                    <P {...item.props}>{item.paragraphText}</P>
                </Wrapper>
            )
        })
    }
    
    return (
        // <Wrapper>
        //     <Icon
        //         {...props}
        //         backgroundImg={backgroundImg}
        //     />
        //     {headerText && <Header {...props}>{headerText}</Header>}
        //     <P {...props}>{paragraphText}</P>
        // </Wrapper>
        <Fragment>
            {renderIconTextLeftToRight(content)}
        </Fragment>
        
    )
}

// const IconTextLeftToRight = ({ 
//     backgroundImg,
//     headerText,
//     paragraphText,
//     ...props
// }) => {

//     return (
//         <Wrapper>
//             <Icon
//                 {...props}
//                 backgroundImg={backgroundImg}
//             />
//             {headerText && <Header {...props}>{headerText}</Header>}
//             <P {...props}>{paragraphText}</P>
//         </Wrapper>
//     )
// }

export default IconTextLeftToRight;